import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchQASpecHistory } from 'services/qaSpec';

export const useGetQaSpecHistory = (productId, enabled = false) => {
  const queryClient = useQueryClient();

  const queryKey = ['qaSpecHistory', productId];

  const query = useQuery({
    queryKey,
    queryFn: () => fetchQASpecHistory(productId),
    enabled: Boolean(enabled && productId),
    refetchOnWindowFocus: false,
  });

  const invalidateQaSpecHistory = () => {
    queryClient.invalidateQueries({ queryKey });
  };

  return { ...query, invalidateQaSpecHistory };
};
